// Phone photos are 3–8 MB; the report needs a clear picture, not the original. They are scaled
// down in the browser (orientation from EXIF applied) to at most 2000 px as JPEG before upload.
const MAX_SIDE = 2000;
const QUALITY = 0.85;

const loadBitmap = async file => {
  if (typeof createImageBitmap === "function") {
    try {
      return await createImageBitmap(file, { imageOrientation: "from-image" });
    } catch {
      // Safari < 16 and HEIC: fall back to an <img>
    }
  }
  const url = URL.createObjectURL(file);
  try {
    const img = new Image();
    img.decoding = "async";
    img.src = url;
    await img.decode();
    return img;
  } finally {
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
};

/** Returns { blob, width, height }; the original file when it cannot be read as an image. */
export const shrinkPhoto = async file => {
  let source;
  try {
    source = await loadBitmap(file);
  } catch {
    return { blob: file, width: 0, height: 0 };
  }
  const width = source.width || source.naturalWidth;
  const height = source.height || source.naturalHeight;
  const scale = Math.min(1, MAX_SIDE / Math.max(width, height));
  if (scale === 1 && file.type === "image/jpeg" && file.size < 1.5 * 1024 * 1024) {
    return { blob: file, width, height };
  }
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(width * scale);
  canvas.height = Math.round(height * scale);
  canvas.getContext("2d").drawImage(source, 0, 0, canvas.width, canvas.height);
  if (typeof source.close === "function") source.close();
  const blob = await new Promise(resolve => canvas.toBlob(resolve, "image/jpeg", QUALITY));
  return { blob: blob || file, width: canvas.width, height: canvas.height };
};
